import { useNavigate } from "react-router-dom";
import { useAronUiStore } from "../store/aronUiStore";

/**
 * A clickable ARON citation. Instead of navigating away (which would lose the
 * conversation from view), it first pops the current conversation into the global
 * right-hand dock, THEN navigates to the cited object's page — so the user reads
 * the record with the ARON thread still visible alongside.
 */
export function AronRefLink({
  to,
  conversationId,
  className,
  title,
  children,
}: {
  to: string;
  conversationId?: string | null;
  className?: string;
  title?: string;
  children: React.ReactNode;
}) {
  const navigate = useNavigate();
  const openDock = useAronUiStore((s) => s.openDock);
  return (
    <a
      href={to}
      className={className}
      title={title}
      onClick={(e) => {
        // Allow ctrl/cmd/middle-click to open in a new tab normally.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        if (conversationId) openDock(conversationId);
        navigate(to);
      }}
    >
      {children}
    </a>
  );
}
